export var BRAND_VALUES = function(strictLocalize) {
    return [
        {
            value: "Not on Amazon",
            label: strictLocalize({
                id: "asZpIW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Not on Amazon"
                    }
                ]
            })
        },
        {
            value: "Eco-Friendly",
            label: strictLocalize({
                id: "ErUPYQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Eco-Friendly"
                    }
                ]
            })
        },
        {
            value: "Small-batch",
            label: strictLocalize({
                id: "FtajKv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Small-batch"
                    }
                ]
            })
        },
        {
            value: "Women Owned",
            label: strictLocalize({
                id: "uh2cSH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Women Owned"
                    }
                ]
            })
        },
        {
            value: "Handmade",
            label: strictLocalize({
                id: "aLnOPA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Handmade"
                    }
                ]
            })
        },
        {
            value: "BIPOC Owned",
            label: strictLocalize({
                id: "8m9pX0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "BIPOC Owned"
                    }
                ]
            })
        },
        {
            value: "Organic",
            label: strictLocalize({
                id: "n5JBQE",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Organic"
                    }
                ]
            })
        }
    ];
};
